<template>
  <section class="max-w-lg mx-auto py-8">
    <h3
      class="mt-0"
      v-html="'Members included in the report should meet <strong>all</strong> of the following characteristics:'"
    />
    <div class="flex flex-wrap justify-between">
      <div class="w-full">
        <AddFilterForm
          v-if="showFilterForm"
          :available-filters="availableFilters"
          @filterAdded="handleFilterAddition"
        />
      </div>
      <div class="w-full mb-8">
        <ActiveFilters
          :active-filters="activeFilters"
          @filterRemoved="handleFilterRemoval"
          @showFilterForm="showFilterForm = true"
        />
      </div>
    </div>
    <div class="flex justify-center m-6">
      <button
        type="button"
        class="btn btn--link mr-4"
        @click="handleBack"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn ml-2"
        @click="handleNext"
        v-text="'Next'"
      />
    </div>
  </section>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex'
import ActiveFilters from './ActiveFilters'
import AddFilterForm from './AddFilterForm'

export default {
  name: 'AddFilters',
  components: {
    ActiveFilters: ActiveFilters,
    AddFilterForm: AddFilterForm,
  },
  props: {
    preSelected: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showFilterForm: false,
      activeFilters: this.preSelected,
      selectedFilter: {
        id: '',
        schema: {},
      },
    }
  },
  computed: {
    ...mapGetters({
      filters: 'membershipGetAvailableReportFilters',
    }),
    availableFilters() {
      return this.filters.filter(filter => !this.alreadyActive(filter.id))
    },
  },
  watch: {
    preSelected(element) {
      if (element) {
        this.activeFilters = element
      }
    },
  },
  async mounted() {
    await this.$nextTick()

    this.getAvailableFilters()
  },
  methods: {
    ...mapActions({
      getAvailableFilters: 'membershipGetAvailableReportFilters',
    }),
    handleNext() {
      this.$emit('tabNavigation', {
        current: 'addFilters',
        direction: 'next',
      })
    },
    handleBack() {
      this.$emit('tabNavigation', {
        current: 'addFilters',
        direction: 'back',
      })
    },
    handleFilterAddition(payload) {
      const found = this.filters.find(filter => filter.id === payload.id)

      payload['title'] = found.attributes.title

      this.activeFilters.push(payload)

      this.showFilterForm = false

      this.$emit('filterAdded', this.activeFilters)
    },
    handleFilterRemoval(payload) {
      this.activeFilters = this.activeFilters.filter(filter => filter.id !== payload.id)

      this.$emit('filterRemoved', this.activeFilters)
    },
    alreadyActive(filterId) {
      return Boolean(this.activeFilters.find(filter => filter.id === filterId))
    },
  },
}
</script>
